import React, { Component } from 'react';
import { Modal,
    Alert,
    Popover,
    OverlayTrigger,
    FormGroup,
    ControlLabel,
    FormControl,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import Validation from 'react-validation';
import LoadingSpinner from './LoadingSpinner';

// To handle requests
import UsersAPI from '../utils/UsersAPI';
import GroupsAPI from '../utils/GroupsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class NewUserButtonComponent extends Component {

    constructor() {
        super();
        const nbItemsPagination = JSON.parse(
           localStorage.getItem('scality-nbitems-groups-new-user-modal')
        );
        this.state = {
            groups: [],
            selectedGroups: [],
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
            nbItems: nbItemsPagination || 2,
            showModal: false,
            showValidation: true,
            modalErrorAlert: '',
            username: '',
            groupsLoaded: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeForm = this.closeForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleGroupSelect = this.handleGroupSelect.bind(this);
        this.handlePreviousPage = this.handlePreviousPage.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.refresh = this.refresh.bind(this);
        this.getGroupRow = this.getGroupRow.bind(this);
        this.submitUser = this.submitUser.bind(this);
    }

    componentWillMount() {
        // Setting validation rules for login form validation
        Object.assign(Validation.rules, {
            // Key name maps the rule
            required: {
                rule: value => (value.toString().trim()),
                hint: () => (<Alert
                  className="margin-t-5"
                  bsStyle="warning">
                This field is required.
              </Alert>),
            },
            validUsername: {
                rule: value => (this.usernameValidator(value)),
                hint: () => (<Alert
                    bsStyle="info"
                    className=" margin-t-5"
                >
                  {'Usernames can contain upper and lowercase'}
                  <strong>{' alphanumeric characters with no spaces.'}</strong>
                  <br />
                   {'Usernames may also include any '}
                   {'of the following characters:'}
                   <strong>{'  =,.@-_+'}</strong>.
                  <br />
                  {'It must have a : '}
                  <strong>
                    {'minimum length of 1 and a maximum length of 64.'}
                  </strong>
              </Alert>),
            },
        });
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true }, this.refresh);
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            groups: [],
            selectedGroups: [],
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
            showModal: false,
            showValidation: false,
            modalErrorAlert: '',
            username: '',
            groupsLoaded: false,
        });
    }

    // Handle text input change to update state
    handleChange(e) {
        this.setState({ username: e.target.value });
    }

    // Handle group selection checkboxes
    handleGroupSelect(e) {
        const currentSelected = this.state.selectedGroups;
        const name = e.target.name;
        const checked = e.target.checked;

        if (checked && currentSelected.indexOf(name) === -1) {
            currentSelected.push(name);
        } else if (!checked && currentSelected.indexOf(name) !== -1) {
            currentSelected.splice(currentSelected.indexOf(name), 1);
        }
        this.setState({ selectedGroups: currentSelected });
    }

    handleNbItemsSelect(event) {
        localStorage.setItem('scality-nbitems-groups-new-user-modal',
        JSON.stringify(event.target.value));
        this.setState({
            nbItems: event.target.value,
            groups: [],
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
        }, this.refresh);
    }

    handlePreviousPage() {
        this.setState({
            currentIndex: this.state.currentIndex - 1,
        });
    }

    handleNextPage() {
        const currentIndex = this.state.currentIndex;
        this.setState({
            currentIndex: this.state.currentIndex + 1,
        });
        if (currentIndex + 1 === this.state.groups.length) {
            this.refresh();
        }
    }

    getGroupRow(item) {
        const checked = this.state.selectedGroups.indexOf(item.GroupName) > -1;
        return (
          <div className="col-md-6" key={item.GroupId}>
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  name={item.GroupName}
                  onChange={this.handleGroupSelect}
                  defaultChecked={checked}
                />
              <i className="fa fa-users" style={brandingStyles.mainColor}/>
                &nbsp;{item.GroupName}
              </label>
            </div>
          </div>
        );
    }

    closeForm() {
        this.closeModal();
        this.setState({ username: '' });
        // Calling specified callback if any
        if (this.props.callback) {
            this.props.callback();
        }
    }

    catchException(message) {
        if (message.status === 401 || message.status === 403) {
            window.location.href = `${namespace}/login/error/${message.status}`;
        } else if (message.status === 409) {
            this.setState({
                modalErrorAlert: `User "${this.state.username}" already
                                  exists.`,
            });
        } else if (message.status === 400) {
            this.setState({
                modalErrorAlert: `Unable to create user.
                                 Please verify that the username is valid.`,
            });
        } else {
            this.setState({
                modalErrorAlert: `Unable to process the request as the
                                 server returned an Internal Error.`,
            });
        }
    }


    // Fired when form is submitted
    submitUser(e) {
        e.preventDefault();
        this.setState({
            modalErrorAlert: '',
            showValidation: false,
        });

        UsersAPI.createUser(this.state.username).then(res => {
            // User has been created successfully
            if (res.user && res.user.UserId) {
                // No group is selected
                if (!this.state.selectedGroups.length) {
                    this.closeForm();
                } else {
                    const groupsPromises = this.state.selectedGroups.map(
                      currentGroup =>
                      GroupsAPI.addUser(this.state.username, currentGroup)
                    );
                    Promise.all(groupsPromises)
                    .then(() => this.closeForm())
                    .catch(message => { this.catchException(message); });
                }
            }
        }).catch(message => {
            this.catchException(message);
        }
        );
    }

    usernameValidator(specUsername) {
        const username = specUsername || this.state.username;

        // Username is too long
        if (username.length > 64) {
            return false;
        }

        // String validation
        const validationRegEx = /^[a-zA-Z0-9=,.@\-_+]*$/;
        return username.match(validationRegEx);
    }

    refresh() {
        GroupsAPI.getGroups(this.state.nbItems, this.state.marker).then(res => {
            const groupPages = this.state.groups;
            groupPages.push(res.groups);
            const toState = {
                groups: groupPages,
                marker: res.marker,
                maxIndex: res.marker ? -1 : this.state.currentIndex,
                groupsLoaded: true,
            };
            this.setState(toState);
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
        });
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const helpPopover = (
            <Popover id="popover-help-username" title="Naming restrictions">
                {'Usernames can contain upper and lowercase alphanumeric ' }
                {'characters with no spaces. Usernames may also include any '}
                {'of the following characters: =,.@-_+. It must have a minimum'}
                {' length of 1 and a maximum length of 64.'}
            </Popover>
        );

        const helpIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={helpPopover}>
                    <i className="fa fa-question-circle-o"></i>
            </OverlayTrigger>
        );

        let groupsItems;
        const currentGroups = this.state.groups[this.state.currentIndex];
        if (currentGroups) {
            groupsItems = currentGroups.map(
              item => this.getGroupRow(item)
            );
        }

        const prevDisabled = this.state.currentIndex === 0;
        const nextDisabled = this.state.currentIndex === this.state.maxIndex;

        const pagerInstance = (
          <ul className="pager padding-l-15 padding-r-15">
            <li
              className={prevDisabled ? 'previous disabled' : 'previous'}
            >
              <a
                className="clickable"
                onClick={this.handlePreviousPage}
                style={brandingStyles.buttons.primary}
              >&larr;</a>
            </li>
            <li
              className={nextDisabled ? 'next disabled' : 'next'}
            >
              <a
                className="clickable"
                onClick={this.handleNextPage}
                style={brandingStyles.buttons.primary}
              >&rarr;</a>
            </li>
          </ul>
        );

        return (
            <div>
                <button
                  className="btn btn-primary new-user-btn"
                  style={brandingStyles.buttons.primary}
                  onClick={this.openModal}
                >
                    <i className="fa fa-plus fa-lg"></i>
                </button>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-user-circle-o"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Add user
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <Validation.components.Form>

                            <div className="form-group">
                              <FormGroup
                                controlId="formValidationError2"
                                validationState={this.usernameValidator()
                                  ? null : 'error'}>
                                <ControlLabel>Username {helpIcon}</ControlLabel>
                                <Validation.components.Input
                                    className="form-control"
                                    style={brandingStyles.backgrounds.input}
                                    type="text"
                                    value={this.state.username}
                                    onChange={this.handleChange}
                                    placeholder="Username"
                                    name="username"
                                    validations={['required',
                                        'validUsername']}/>
                                <FormControl.Feedback />
                              </FormGroup>

                            </div>
                            {errorAlert}

                            <hr />

                            <div className="padding-15 padding-l-0">
                              <div style={{
                                  display: 'inline-block',
                              }}>
                                <strong>Add user to these groups : </strong>
                              </div>
                              <select
                                className="pull-right form-control
                                pagination-select"
                                style={brandingStyles.backgrounds.input}
                                value={this.state.nbItems}
                                onChange={this.handleNbItemsSelect.bind(this)}
                              >
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                            </div>
                            <div className="row">
                              {this.state.groupsLoaded
                                ? groupsItems : <LoadingSpinner />}
                            </div>
                            {pagerInstance}
                            <Validation.components.Button
                              onClick={this.submitUser}
                              className="btn btn-primary pull-right"
                              style={brandingStyles.buttons.primary}
                            >
                              Submit
                            </Validation.components.Button>

                        </Validation.components.Form>
                        <div style={{
                            clear: 'both',
                        }}></div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }

}

NewUserButtonComponent.propTypes = {
    callback: PropTypes.func,
};

export default NewUserButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/NewUserButton.js
 **/